"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var presetRanges = [{
  label: 'Today',
  amount: 1,
  unit: 'days'
}, {
  label: 'Since Yesterday',
  amount: 2,
  unit: 'days'
}, {
  label: 'Last 7 Days',
  amount: 7,
  unit: 'days'
}, {
  label: 'Last 30 Days',
  amount: 30,
  unit: 'days'
}, {
  label: 'Quarter to Date',
  amount: 1,
  unit: 'quarter'
}, {
  label: 'Year to Date',
  amount: 1,
  unit: 'year'
}, {
  label: 'Last Year',
  amount: 1,
  unit: 'year'
}, {
  label: 'Last 2 Years',
  amount: 2,
  unit: 'year'
}];

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PresetMenu__Wrapper",
  componentId: "sc-1xu1cvf-0"
})(["display:flex;flex-flow:column nowrap;justify-content:flex-start;position:absolute;right:0;width:172px;top:43px;height:calc(100% - 43px);z-index:2;padding-top:1rem;border-left:1px solid #c3cdd9;"]);

var PresetDate = _styledComponents.default.div.withConfig({
  displayName: "PresetMenu__PresetDate",
  componentId: "sc-1xu1cvf-1"
})(["padding:0.75rem 0 0.75rem 2.5rem;cursor:pointer;color:#77899e;&.active{color:#343e47;font-weight:500;border-left:4px solid #1385f0;padding-left:2.1rem;}"]);

var PresetMenu = function PresetMenu(_ref) {
  var onPresetClick = _ref.onPresetClick,
      checkPresetActive = _ref.checkPresetActive;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "DateRangePicker__PresetMenu"
  }, presetRanges.map(function (_ref2) {
    var amount = _ref2.amount,
        label = _ref2.label,
        unit = _ref2.unit;
    var isActive = checkPresetActive({
      amount: amount,
      label: label,
      unit: unit
    });
    return /*#__PURE__*/_react.default.createElement(PresetDate, {
      key: label,
      className: isActive && 'active',
      onClick: function onClick() {
        return onPresetClick({
          amount: amount,
          label: label,
          unit: unit
        });
      }
    }, label);
  }));
};

PresetMenu.propTypes = {
  onPresetClick: _propTypes.default.func.isRequired,
  checkPresetActive: _propTypes.default.func.isRequired
};
var _default = PresetMenu;
exports.default = _default;